import React from 'react'
import { t } from 'ttag'

import { DeleteResourceModal } from 'components/modals/common/DeleteResourceModal/DeleteResourceModal'

export const DeleteDepartmentAccessModal = ({
  onCancel,
  onClose,
  onConfirm,
  isOpen,
}) => (
  <DeleteResourceModal
    alert={t`The user will lose access to all jobs within this Department.`}
    title={t`Remove Department access`}
    {...{ onCancel, onClose, onConfirm, isOpen }}
  />
)
